module.exports = __webpack_public_path__ + "img/Kofferraumparty.73bcb326.jpg";